// @module NetScore.PDPErrMessage.PDPErrMessage
define('NetScore.PDPErrMessage.PDPErrMessage.View'
,	[
		'netscore_pdperrmessage_pdperrmessage.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	,	'LiveOrder.Model'
    ,   'SC.Configuration'
	]
,	function (
		netscore_pdperrmessage_pdperrmessage_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	,	LiveOrderModel
    ,   Configuration
	)
{
	'use strict';
	var pdp,
    	quickview,
    	cart;

	// @class NetScore.PDPErrMessage.PDPErrMessage.View @extends Backbone.View
	return Backbone.View.extend({
        template: netscore_pdperrmessage_pdperrmessage_tpl,
        initialize: function(options) {
                quickview = options.quickview
                // console.log('quickviewss', quickview);
                pdp = options.pdp;
            },
        events: {
            'click [data-action="sticky"]': 'allowcart'
        },
        bindings: {

        },
        childViews: {

        },
        allowcart: function(ac) {
            // console.log("qkview1234", quickview);
            var pdp = this.options.pdp;
            //console.log("pdp",pdp);
            var item_info = pdp.getItemInfo();
            // console.log("item_info", item_info);

            var cc1 = pdp.getSelectedMatrixChilds();
            //console.log('cc1', cc1);
            if(cc1.length==1)
            {
            var available_qty = cc1[0].quantityavailable;
			//var available_qty = 10;
             //console.log("available_qty", available_qty);

            var livemodel = LiveOrderModel.getInstance();
            // console.log('model234', livemodel);
            var item_id = cc1[0].internalid;
            // console.log('item_id', item_id);
            var length = livemodel.attributes.lines.length;
            // console.log("length", length);
            var item_already_in_cart = 0;
            for (var i = 0; i < length; i++) {
                var cart_item_id = livemodel.attributes.lines.models[i].attributes.item.id;
                // console.log("cart_item_id", cart_item_id);
                if (livemodel.attributes.lines.models[i].attributes.item.id == item_id) {
                    var tem_status = 5;
                    // console.log("tem_status", tem_status);
                    item_already_in_cart = livemodel.attributes.lines.models[i].attributes.quantity;
                     //console.log("item_already_in_cart", item_already_in_cart);
                }
                
            }
			 var max_order_amnt =cc1[0].keyMapping_maximumQuantity;
			//var max_order_amnt =200;
			//console.log("max_order_amnt", max_order_amnt);
           var maximum_order_amnt = max_order_amnt - item_already_in_cart;
		   //console.log("maximum_order_amnt",maximum_order_amnt);
           
            var item_info = pdp.getItemInfo();
            // console.log("item_info", item_info);
            var quantity_ordered_pdp = item_info.quantity;
            //console.log('quantity_ordered_pdp', quantity_ordered_pdp);
            var msg=SC.CONFIGURATION.PDPErrMessage.PDPErrorMessage;
            // console.log("msg",msg);
            //var msg="We only have | pieces of  remaining. You can order maximum | pieces at a time.Since you Already have | pieces of this item is in your cart.So you can add maximum | pieces to your cart. ";
            //var msg="You can order a maximum of | pieces .Since you Already have | pieces in your cart.";
			//console.log("msg",msg);
            var msg1=msg.split('|');
            //console.log("msg1",msg1);
            var msg_part=msg1.length;
            //console.log("msg_part",msg_part);

            if (quickview != "QuickView") {
				if(max_order_amnt==undefined)		
				{
				maximum_order_amnt=available_qty - item_already_in_cart;
				if(maximum_order_amnt < 0){
                   maximum_order_amnt = 0;
                    }
				if(quantity_ordered_pdp> maximum_order_amnt)		
		       {
				  //console.log("sam");
                    $("#changequantity").show();
                    $("#changequantity").html( msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#quantity").val(quantity_ordered_pdp);
                    return false;
		        }
				}
			else{	

		 if(max_order_amnt>available_qty)		
		       {
				   maximum_order_amnt=available_qty-item_already_in_cart;
				     if(maximum_order_amnt < 0){
                        maximum_order_amnt = 0;
                    }
					if(quantity_ordered_pdp> maximum_order_amnt)
					{
		
				  //console.log("sambit456");
                    $("#changequantity").show();
                     $("#changequantity").html(  msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#quantity").val(quantity_ordered_pdp);
                    return false;
		        }
               }
				else if(quantity_ordered_pdp> maximum_order_amnt)		
		             {
					   if(maximum_order_amnt < 0){
                        maximum_order_amnt = 0;
                      }
					 maximum_order_amnt=max_order_amnt-item_already_in_cart;
				 // console.log("sambitt");
                    $("#changequantity").show();
                   $("#changequantity").html( msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#quantity").val(quantity_ordered_pdp);
                    return false;
		        }
               else if (quantity_ordered_pdp > max_order_amnt) {
                    if(max_order_amnt < 0){
                        max_order_amnt = 0;
                    }
					maximum_order_amnt=max_order_amnt-item_already_in_cart;
					//console.log("sambi12");
					
                    $("#changequantity").show();
                    $("#changequantity").html(  msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#quantity").val(quantity_ordered_pdp);
                    return false;
                } 
		
		
				else if(quantity_ordered_pdp> available_qty) {
				   maximum_order_amnt=max_order_amnt-item_already_in_cart;
				  //console.log("sambit780");
                    $("#changequantity").show();
                    $("#changequantity").html( msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#quantity").val(quantity_ordered_pdp);
                    return false;
		        }
				
				else {

                    $("#changequantity").hide();
                }
			}         
		   }
		else{
        	if(max_order_amnt==undefined)		
				{
				maximum_order_amnt=available_qty - item_already_in_cart;
				if(maximum_order_amnt < 0){
                   maximum_order_amnt = 0;
                    }
				if(quantity_ordered_pdp> maximum_order_amnt)		
		       {
				  maximum_order_amnt=available_qty - item_already_in_cart;
				  //console.log("sam");
                    $("#in-modal-changequantity").show();
                    $("#in-modal-changequantity").html( msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#in-modal-quantity").val(quantity_ordered_pdp);
                    return false;
		        }
				}
			else{	

		 if(max_order_amnt>available_qty)		
		       {
				   maximum_order_amnt=available_qty-item_already_in_cart;
				     if(maximum_order_amnt < 0){
                        maximum_order_amnt = 0;
                    }
				 if(quantity_ordered_pdp> maximum_order_amnt)
					{
		
				  //console.log("sambit456");
                    $("#in-modal-changequantity").show();
                     $("#in-modal-changequantity").html(  msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#in-modal-quantity").val(quantity_ordered_pdp);
                    return false;
		        }
		        }

				else if(quantity_ordered_pdp> maximum_order_amnt)		
		             {
					   if(maximum_order_amnt < 0){
                        maximum_order_amnt = 0;
                      }
					 maximum_order_amnt=max_order_amnt-item_already_in_cart;
				  //console.log("sambitt");
                    $("#in-modal-changequantity").show();
                   $("#in-modal-changequantity").html( msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#in-modal-quantity").val(quantity_ordered_pdp);
                    return false;
		        }
               else if (quantity_ordered_pdp > max_order_amnt) {
                    if(max_order_amnt < 0){
                        max_order_amnt = 0;
                    }
					maximum_order_amnt=max_order_amnt-item_already_in_cart;
					//console.log("sambi12");
					
                    $("#in-modal-changequantity").show();
                    $("#in-modal-changequantity").html(  msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#in-modal-quantity").val(quantity_ordered_pdp);
                    return false;
                } 
		
		
				else if(quantity_ordered_pdp> available_qty) {
				   maximum_order_amnt=max_order_amnt-item_already_in_cart;
				  //console.log("sambit780");
                    $("#in-modal-changequantity").show();
                    $("#in-modal-changequantity").html( msg1[0] +   + maximum_order_amnt + msg1[1]+ +item_already_in_cart+msg1[2] );
                    // $("#changequantity").html("We only have " + available_qty + " pieces available. You can order a maximum " + max_order_amnt + " pieces since you already have " + item_already_in_cart + " pieces in your cart.");
                    $("#in-modal-quantity").val(quantity_ordered_pdp);
                    return false;
		        }
				
				else {

                    $("#in-modal-changequantity").hide();
                }
			}       
            }
        }
    }

        //@method getContext @return NetScore.PDPerrMsg.PDPerrMsg.View.Context
    ,   getContext: function getContext() {
            
            var pdp = this.options.pdp;
        }
    });
});
